import DialCodes from '@/configuration/sources/DialCodes.yml'

export default class PhoneField {
  constructor(name, dnaConfig) {
    this.name = name
    const { areaCode, maxSize, minSize } = dnaConfig

    // Setup validation info
    this.minSize = minSize ?? 3
    this.maxSize = maxSize ?? null
    this.prefix = areaCode

    // Setup initial value
    this.value = areaCode

    // Setup component
    const country = PhoneField.getCountryFromPrefix(areaCode)
    this.component = {
      name: 'KryptonPhoneInput',
      props: {
        fieldName: name,
        displayedCountries: [country],
        defaultCountry: country
      }
    }
  }

  getErrors() {
    const rawVal = this.value.replace(this.prefix, '')
    const isValid =
      rawVal.length >= this.minSize &&
      (!this.maxSize || rawVal.length <= this.maxSize)

    if (!isValid)
      return { errorCode: 'CLIENT_314', field: this.name, formId: null }
  }

  static getCountryFromPrefix(areaCode) {
    const country = DialCodes.countries.find(
      ({ prefix }) => prefix === areaCode
    )
    return country ? country.countryCode : ''
  }
}
